// src/pages/ApplicationSeason/breadcrumb.ts
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import { t } from '@/i18n';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_season.breadcrumb.seasons_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_season.breadcrumb.seasons_label2'),
    link: '/application/championships',
  },
  {
    label: t('pages.application_season.breadcrumb.seasons_label3'),
  },
];
